/**
 * Mapping von Abwesenheitsart-Farbnamen zu Tailwind CSS-Klassen.
 * Zentrale Stelle für Kalender-DayCell und Legend.
 */

export interface AbsenceColorClasses {
  bg: string;
  text: string;
  darkBg: string;
  darkText: string;
}

export const ABSENCE_COLOR_CLASSES: Record<string, AbsenceColorClasses> = {
  blue: {
    bg: 'bg-blue-100',
    text: 'text-blue-800',
    darkBg: 'dark:bg-blue-900/30',
    darkText: 'dark:text-blue-300',
  },
  red: {
    bg: 'bg-red-100',
    text: 'text-red-800',
    darkBg: 'dark:bg-red-900/30',
    darkText: 'dark:text-red-300',
  },
  indigo: {
    bg: 'bg-indigo-100',
    text: 'text-indigo-800',
    darkBg: 'dark:bg-indigo-900/30',
    darkText: 'dark:text-indigo-300',
  },
  amber: {
    bg: 'bg-amber-100',
    text: 'text-amber-800',
    darkBg: 'dark:bg-amber-900/30',
    darkText: 'dark:text-amber-300',
  },
  purple: {
    bg: 'bg-purple-100',
    text: 'text-purple-800',
    darkBg: 'dark:bg-purple-900/30',
    darkText: 'dark:text-purple-300',
  },
  teal: {
    bg: 'bg-teal-100',
    text: 'text-teal-800',
    darkBg: 'dark:bg-teal-900/30',
    darkText: 'dark:text-teal-300',
  },
  pink: {
    bg: 'bg-pink-100',
    text: 'text-pink-800',
    darkBg: 'dark:bg-pink-900/30',
    darkText: 'dark:text-pink-300',
  },
  orange: {
    bg: 'bg-orange-100',
    text: 'text-orange-800',
    darkBg: 'dark:bg-orange-900/30',
    darkText: 'dark:text-orange-300',
  },
  cyan: {
    bg: 'bg-cyan-100',
    text: 'text-cyan-800',
    darkBg: 'dark:bg-cyan-900/30',
    darkText: 'dark:text-cyan-300',
  },
  lime: {
    bg: 'bg-lime-100',
    text: 'text-lime-800',
    darkBg: 'dark:bg-lime-900/30',
    darkText: 'dark:text-lime-300',
  },
};
